/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi.com Payments API
 * An API for Kiwi.com payments.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PaymentOrderViewGooglePayPaymentRequestAllowedPaymentMethodsInnerParametersBillingAddressParametersFromJSON, PaymentOrderViewGooglePayPaymentRequestAllowedPaymentMethodsInnerParametersBillingAddressParametersToJSON, } from './PaymentOrderViewGooglePayPaymentRequestAllowedPaymentMethodsInnerParametersBillingAddressParameters';
/**
 * @export
 */
export const PaymentOrderViewGooglePayPaymentRequestAllowedPaymentMethodsInnerParametersAllowedAuthMethodsEnum = {
    PanOnly: 'PAN_ONLY',
    Cryptogram3Ds: 'CRYPTOGRAM_3DS'
};
/**
 * @export
 */
export const PaymentOrderViewGooglePayPaymentRequestAllowedPaymentMethodsInnerParametersAllowedCardNetworksEnum = {
    Amex: 'AMEX',
    Discover: 'DISCOVER',
    Interac: 'INTERAC',
    Jcb: 'JCB',
    Mastercard: 'MASTERCARD',
    Visa: 'VISA',
    Elo: 'ELO',
    EloDebit: 'ELO_DEBIT',
    Electron: 'ELECTRON',
    Maestro: 'MAESTRO'
};
/**
 * Check if a given object implements the PaymentOrderViewGooglePayPaymentRequestAllowedPaymentMethodsInnerParameters interface.
 */
export function instanceOfPaymentOrderViewGooglePayPaymentRequestAllowedPaymentMethodsInnerParameters(value) {
    if (!('allowedAuthMethods' in value) || value['allowedAuthMethods'] === undefined)
        return false;
    if (!('allowedCardNetworks' in value) || value['allowedCardNetworks'] === undefined)
        return false;
    return true;
}
export function PaymentOrderViewGooglePayPaymentRequestAllowedPaymentMethodsInnerParametersFromJSON(json) {
    return PaymentOrderViewGooglePayPaymentRequestAllowedPaymentMethodsInnerParametersFromJSONTyped(json, false);
}
export function PaymentOrderViewGooglePayPaymentRequestAllowedPaymentMethodsInnerParametersFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'allowCreditCards': json['allow_credit_cards'] == null ? undefined : json['allow_credit_cards'],
        'allowPrepaidCards': json['allow_prepaid_cards'] == null ? undefined : json['allow_prepaid_cards'],
        'allowedAuthMethods': json['allowed_auth_methods'],
        'allowedCardNetworks': json['allowed_card_networks'],
        'assuranceDetailsRequired': json['assurance_details_required'] == null ? undefined : json['assurance_details_required'],
        'billingAddressParameters': json['billing_address_parameters'] == null ? undefined : PaymentOrderViewGooglePayPaymentRequestAllowedPaymentMethodsInnerParametersBillingAddressParametersFromJSON(json['billing_address_parameters']),
        'billingAddressRequired': json['billing_address_required'] == null ? undefined : json['billing_address_required'],
    };
}
export function PaymentOrderViewGooglePayPaymentRequestAllowedPaymentMethodsInnerParametersToJSON(json) {
    return PaymentOrderViewGooglePayPaymentRequestAllowedPaymentMethodsInnerParametersToJSONTyped(json, false);
}
export function PaymentOrderViewGooglePayPaymentRequestAllowedPaymentMethodsInnerParametersToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'allow_credit_cards': value['allowCreditCards'],
        'allow_prepaid_cards': value['allowPrepaidCards'],
        'allowed_auth_methods': value['allowedAuthMethods'],
        'allowed_card_networks': value['allowedCardNetworks'],
        'assurance_details_required': value['assuranceDetailsRequired'],
        'billing_address_parameters': PaymentOrderViewGooglePayPaymentRequestAllowedPaymentMethodsInnerParametersBillingAddressParametersToJSON(value['billingAddressParameters']),
        'billing_address_required': value['billingAddressRequired'],
    };
}
